export const MANAGEMENT_ROLES = ["super_admin", "cxo"];
export const FINANCIAL_ROLES = ["super_admin", "cxo", "strategy"];
export const EDITOR_ROLES = ["super_admin", "cxo", "strategy", "direction", "planning"];
export const USER_MANAGER_ROLES = [...MANAGEMENT_ROLES, "strategy"];
export const CUSTOMIZATION_ROLES = [...USER_MANAGER_ROLES];
export const ROLE_LEVELS = { planning: 1, direction: 2, strategy: 3, cxo: 4, super_admin: 5 };

export const permissionsFor = (role) => ({
  canManage: MANAGEMENT_ROLES.includes(role),
  canManageUsers: USER_MANAGER_ROLES.includes(role),
  canCustomize: CUSTOMIZATION_ROLES.includes(role),
  canEdit: EDITOR_ROLES.includes(role),
  canViewFinancial: FINANCIAL_ROLES.includes(role),
  canAudit: role === "super_admin",
});